"use strict";

const _ = require('lodash');
const {format: dtFormat} = require('date-fns');
const numeral = require('numeral');

function format(k, {dateFormat, numberFormat} = {}) {
	if (_.isDate(k)) {
		if (dateFormat) {
			return dtFormat(k, dateFormat);
		}
		let h = k.getHours();
		if (!h) {
			return dtFormat(k, 'd/M/yy');
		} else {
			return dtFormat(k, 'd/M/yy ha');
		}
	}

	if (_.isNumber(k)) {
		return numeral(k).format(numberFormat || '0[.]00');
	}

	if (!k) {
		return '';
	}
	return k.toString();
}

module.exports = format;